import React, { useContext } from "react";
import { TutorialModal } from "../tutorial-modal";
import { CREATE_PROFILE_DATA } from "../data/create-profile-data";
import { store } from "../../Store";

/**
 * Wrapper del tutorial de crear perfil.
 * Su visibilidad depende del estado global `personalAccountTutorials.createProfileVisible`.
 * @returns {JSX.Element}
 */
export const CreateProfileTutorial = () => {
	const globalState = useContext(store);
	const visible = globalState?.state?.personalAccountTutorials?.createProfileVisible;

	/**
	 * Actualiza el flag global de visibilidad del tutorial.
	 * @param {boolean} newVisible
	 */
	const setVisible = (newVisible) => {
		globalState.dispatch({
			type: "CHANGE",
			path: "personalAccountTutorials.createProfileVisible",
			value: newVisible,
		});
	};

	/**
	 * Cierra el tutorial y apaga su flag global.
	 */
	const handleClose = () => {
		setVisible(false);
	};

	return (
		<TutorialModal
			visible={visible}
			setVisible={setVisible}
			onClose={handleClose}
			steps={CREATE_PROFILE_DATA}
			modalId="create-profile-tutorial"
		/>
	);
};
